import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../_services/_nav.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {Table} from 'primeng/table';
import {Funcionalidad} from '../../_models/funcionalidad';
import {FormaDesembolsoService} from '../../_services/forma-desembolso.service';
import {FormaDesembolso} from '../../_models/forma-desembolso';

@Component({
  selector: 'app-especie',
  templateUrl: 'forma-desembolso.component.html'
})

export class FormaDesembolsoComponent implements OnInit {

  formaDesembolso: FormaDesembolso;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  lisFormaDesembolso: FormaDesembolso[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(private serFormaDesembolso: FormaDesembolsoService,
              private navServicio: NavService,
              private route: ActivatedRoute,
              private location: Location,
              private fb: FormBuilder,
              private autServicio: AutenticacionService,
              private conServicio: ConfirmationService,
              private router: Router) {
  }

  ngOnInit(): void {
    /** Se traen todas las formas de desembolso xvgc */
    this.serFormaDesembolso.listado().subscribe(formaDesembolso => {
      this.lisFormaDesembolso = formaDesembolso;
      this.carServiciosIniciales();
    });

  }

  carServiciosIniciales() {
    const mn = this.autServicio.obtenerFuncionalidades().find(x => x.ruta === 'apl/forma-desembolso');
    if (mn) {
      this.menu = mn;
    }
    //definiendo columnas datatable
    this.columnas = [
      {field: 'codigo', header: this.navServicio.buscarMensaje('LBL_CODIGO'), sort: false},
      {field: 'nombre', header: this.navServicio.buscarMensaje('FORMADESEMBOLSO.LBL_TIPOESPECIE'), sort: false},
      {field: 'porcentaje', header: this.navServicio.buscarMensaje('FORMADESEMBOLSO.LBL_PORCENDESEM'), sort: false},
      {field: 'desembolso', header: this.navServicio.buscarMensaje('LBL_DESCRIPCIONESPECIE'), sort: false},
      {field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje('LBL_HABILITADO'), sort: false},
      {field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false}
    ];
    //inicializando formulario
    this.formulario = this.fb.group({
      idFormaDesembolso: [this.formaDesembolso ? this.formaDesembolso.idFormaDesembolso : null],
      codigo: [this.formaDesembolso ? this.formaDesembolso.codigo : null, [Validators.required, Validators.maxLength(10)]],
      nombre: [this.formaDesembolso ? this.formaDesembolso.nombre : null, [Validators.required, Validators.maxLength(50)]],
      porcentaje: [this.formaDesembolso ? this.formaDesembolso.porcentaje : null, [Validators.required]],
      indicadorHabilitado: [this.formaDesembolso ? this.formaDesembolso.indicadorHabilitado : true, [Validators.required]],
      descripcion: [this.formaDesembolso ? this.formaDesembolso.descripcion : null, [Validators.required, Validators.maxLength(250)]],
    });

    this.busqueda = this.navServicio.getSearch('forma-desembolso.component');
    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      if (this.formaDesembolso && (this.formaDesembolso.idFormaDesembolso !== '' && this.formaDesembolso.idFormaDesembolso !== null && this.formaDesembolso.idFormaDesembolso !== undefined)) {
        //se actualiza la forma desembolso
        this.actualizarFormaDesembolso(formulario);
      } else {
        //Se guarda la forma desembolso
        this.guardarFormaDesembolso(formulario);
      }

    }
  }

  guardarFormaDesembolso(formulario) {
    let noExisteCodigo: boolean = true;
    let noExisteNombre: boolean = true;
    if (this.existeCodigo()) {
      noExisteCodigo = false;
    }
    if (this.existeNombre()) {
      noExisteNombre = false;
    }
    if (noExisteCodigo && noExisteNombre) {
      /** Se crea la forma desembolso */
      this.serFormaDesembolso.crear(formulario).subscribe(formaDesem => {
        this.lisFormaDesembolso = [];
        this.serFormaDesembolso.listado().subscribe(reg => {
          this.lisFormaDesembolso = reg;
          this.guardando = false;
          this.submitted = false;
          this.codExiste = false;
          this.carTabla = false;
          this.formaDesembolso = null;
          this.formulario.reset();
          this.f.indicadorHabilitado.setValue(true);
          this.navServicio.setMesage(0, {
            severity: 'success', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
            detail: this.navServicio.buscarMensaje('FORMADESEMBOLSO.MSG_CREO')
          });
        });
      });
    } else {
      //se muestra un mensaje de código en uso
      if (noExisteCodigo === false) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('FORMADESEMBOLSO.MSG_ERRORCODIGO')
        });
        this.guardando = false;
        this.carTabla = false;
      }
      //se muestra un mensaje de nombre en uso (Tipo especie)
      if (noExisteNombre === false) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('FORMADESEMBOLSO.MSG_ERRORNOMBRE')
        });
        this.guardando = false;
        this.carTabla = false;
      }
    }
  }
  actualizarFormaDesembolso(formulario) {
    /** Se actualiza la forma desembolso */
    console.log(this.existeNombreExcluido());
    if (this.existeNombreExcluido()) {
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('FORMADESEMBOLSO.MSG_ERRORNOMBRE')
      });
      this.guardando = false;
      this.carTabla = false;
    } else {
      this.serFormaDesembolso.actualizar(formulario).subscribe(tipoRespaldoCategoria => {
        this.lisFormaDesembolso = [];
        //se obtiene el listado de formas desembolso
        this.serFormaDesembolso.listado().subscribe(reg => {
          this.lisFormaDesembolso = reg;
          this.guardando = false;
          this.submitted = false;
          this.codExiste = false;
          this.carTabla = false;
          this.formaDesembolso = null;
          this.formulario.reset();
          this.f.indicadorHabilitado.setValue(true);
          //se presenta un mensaje de actualización en pantalla
          this.navServicio.setMesage(0, {
            severity: 'success', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
            detail: this.navServicio.buscarMensaje('TIPORESPALDO.MSG_ACTUALIZO')
          });
        });
      });
    }
  }

  existeCodigo(): boolean {
    //verifica si existe una formaDesembolso que tenga el codigo que se está ingresando en el formulario
    const codigo = this.f.codigo.value;
    const formaDes = !(this.lisFormaDesembolso.find(x => x.codigo === codigo));
    return !formaDes;
    // return !(this.lisFormaDesembolso.find( x => x.codigo === codigo && !x.indicadorHabilitado ));
  }

  existeNombre(): boolean {
    //verifica si existe una formaDesembolso que tenga el nombre que se está ingresando en el formulario
    const nombre = this.f.nombre.value;
    const formaDes = !(this.lisFormaDesembolso.find(x => x.nombre === nombre));
    return !formaDes;
    // return !(this.lisFormaDesembolso.find( x => x.codigo === codigo && !x.indicadorHabilitado ));
  }

  existeNombreExcluido(): boolean {
    //verifica si existe una formaDesembolso que tenga el nombre que se está ingresando en el formulario
    //se excluye el nombre de la formaDesembolso que se está editando
    const nombre = this.f.nombre.value;
    const idFormaDesembolso = this.formaDesembolso.idFormaDesembolso;
    const formaDes = !(this.lisFormaDesembolso.find(x => x.nombre === nombre && x.idFormaDesembolso !== idFormaDesembolso));
    return !formaDes;
  }

  get f() {
    return this.formulario.controls;
  }

  setBusqueda() {
    this.navServicio.setSearch('forma-desembolso.component', this.busqueda);
  }

  editar(formaDesembolso: FormaDesembolso) {
    this.formaDesembolso = formaDesembolso;
    this.formulario.reset();
    this.f.idFormaDesembolso.setValue(this.formaDesembolso.idFormaDesembolso);
    this.f.porcentaje.setValue(this.formaDesembolso.porcentaje);
    this.f.codigo.setValue(this.formaDesembolso.codigo);
    this.f.nombre.setValue(this.formaDesembolso.nombre);
    this.f.descripcion.setValue(this.formaDesembolso.descripcion);
    this.f.indicadorHabilitado.setValue(this.formaDesembolso.indicadorHabilitado);
  }

}
